import { AlertType } from './AlertType';

// Model definition for properties for cdx-alert
export class Alert {
	title: string;
	description: string;
	alertType: AlertType;
}
